import { Box } from 'components/Box';
import { PrimaryButton } from 'components/Button';
import { Icon } from 'components/Icon';
import { Link } from 'components/Link';
import { BodySmall } from 'components/Text/BodySmall';
import { CmsApiMiniPage } from 'modules/cms/api/types/CmsApiMiniPage';
import { CmsApiPage } from 'modules/cms/api/types/CmsApiPage';
import { colors, gutterWidth, shadows } from 'theme';

import { BreadCrumbs, Input } from './AmpPostSearchToolbar.styled';

type Props = {
  content: CmsApiPage;
  homePage: CmsApiMiniPage;
  searchMode: boolean;
};

export function AmpPostSearchToolbar({ content, homePage, searchMode }: Props) {
  const isHomePage = homePage && homePage.url === content.url;
  const hasBreadcrumbs = !isHomePage || (isHomePage && searchMode);
  return (
    <Box
      position="relative"
      zIndex={1}
      py={12}
      px={gutterWidth / 2}
      classes={['flex', 'align-center', 'justify-between']}
      flexWrap="wrap"
      bg={colors.white}
      borderTop={`1px solid ${colors.platinum}`}
      boxShadow={shadows.toolbar}
    >
      <Box width="50%" flex="0 0 auto" pr={16}>
        {hasBreadcrumbs && (
          <BreadCrumbs
            alignItems="center"
            data-qa-id="breadcrumbs"
            whiteSpace="nowrap"
            overflow="hidden"
            textOverflow="ellipsis"
          >
            <BodySmall color={colors.battleshipGrey}>
              <Link href={`/${content.subsite && homePage.url}`}>
                {content.subsite && homePage.title}
              </Link>
            </BodySmall>
            {!isHomePage && (
              <>
                <Box mx={16}>
                  <Icon
                    initialColorName="todo-replace-me"
                    name="chevron-right"
                    size={9}
                  />
                </Box>
                <BodySmall styleAs="h5">
                  <Link href={`/${content.url}`}>{content.title}</Link>
                </BodySmall>
              </>
            )}
          </BreadCrumbs>
        )}
      </Box>
      <Box width={586} maxWidth="50%" justifyContent="flex-end" display="flex">
        <form
          action={`/${homePage.url}`}
          target="_top"
          data-initialize-from-url
        >
          <Box display="flex" position="relative">
            <input name="searchMode" value="true" hidden />
            <Input
              name="pq"
              placeholder={getText('Search articles')}
              data-allow-initialization
            />
            <Box position="absolute" top="7px" right="7px">
              <Box component={PrimaryButton} type="submit" small minWidth={80}>
                {getText('Search')}
              </Box>
            </Box>
          </Box>
        </form>
      </Box>
    </Box>
  );
}
